'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _matcher__step = require('./matcher__step1.vue');

var _matcher__step2 = _interopRequireDefault(_matcher__step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        step1: _matcher__step2.default
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div>\n    <step1></step1>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-65084ef0", module.exports)
  } else {
    hotAPI.update("_v-65084ef0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}